"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TextArea = _interopRequireDefault(require("./TextArea"));
var _Password = _interopRequireDefault(require("./Password"));
var _Search = _interopRequireDefault(require("./Search"));
var _InputGroup = _interopRequireDefault(require("./InputGroup"));
var _utils = require("../utils");
var _configProvider = require("../config-provider/configProvider");
var _icon = _interopRequireDefault(require("../icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Input = /*#__PURE__*/function (_PureComponent) {
  function Input(props) {
    var _previewToggle$previe;
    var _this;
    (0, _classCallCheck2.default)(this, Input);
    _this = _callSuper(this, Input, [props]);
    (0, _defineProperty2.default)(_this, "inputRef", void 0);
    (0, _defineProperty2.default)(_this, "value", void 0);
    (0, _defineProperty2.default)(_this, "isComposing", void 0);
    (0, _defineProperty2.default)(_this, "handlePreviewChange", function () {
      var preview = _this.state.preview;
      var newPreview = !preview;
      _this.setState({
        preview: newPreview
      }, function () {
        if (!_this.state.preview) {
          var _this$inputRef$curren;
          (_this$inputRef$curren = _this.inputRef.current) === null || _this$inputRef$curren === void 0 || _this$inputRef$curren.focus();
        }
      });
      var previewToggle = _this.props.previewToggle;
      if (!(0, _utils.isBoolean)(previewToggle)) {
        var _previewToggle$onPrev;
        previewToggle === null || previewToggle === void 0 || (_previewToggle$onPrev = previewToggle.onPreviewChange) === null || _previewToggle$onPrev === void 0 || _previewToggle$onPrev.call(previewToggle, newPreview);
      }
    });
    (0, _defineProperty2.default)(_this, "focus", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$cursor = _ref.cursor,
        cursor = _ref$cursor === void 0 ? null : _ref$cursor;
      _this.inputRef.current.focus();
      if (_this.props.type !== 'text') {
        return;
      }
      if (cursor === 'start') {
        var _this$inputRef$curren2;
        (_this$inputRef$curren2 = _this.inputRef.current) === null || _this$inputRef$curren2 === void 0 || _this$inputRef$curren2.setSelectionRange(0, 0);
      } else if (cursor === 'end') {
        var _value$length, _this$inputRef$curren3;
        var value = _this.state.value;
        var valueLength = (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0;
        (_this$inputRef$curren3 = _this.inputRef.current) === null || _this$inputRef$curren3 === void 0 || _this$inputRef$curren3.setSelectionRange(valueLength, valueLength);
      } else if (cursor === 'all') {
        var _this$inputRef$curren4, _this$inputRef$curren5;
        (_this$inputRef$curren4 = _this.inputRef.current) === null || _this$inputRef$curren4 === void 0 || (_this$inputRef$curren5 = _this$inputRef$curren4.select) === null || _this$inputRef$curren5 === void 0 || _this$inputRef$curren5.call(_this$inputRef$curren4);
      }
    });
    _this.inputRef = /*#__PURE__*/_react.default.createRef();
    var _previewToggle = props.previewToggle,
      _value = props.value,
      type = props.type;
    var fixControlledValue = _value !== null && _value !== void 0 ? _value : '';
    ['handleBlur', 'handleClear', 'handleKeyDown', 'handleInput', 'handleChange', 'handleCompositionStart', 'handleCompositionEnd'].forEach(function (fn) {
      return _this[fn] = _this[fn].bind(_this);
    });
    var initPreview = (0, _utils.isBoolean)(_previewToggle) ? _previewToggle : (_previewToggle$previe = _previewToggle === null || _previewToggle === void 0 ? void 0 : _previewToggle.preview) !== null && _previewToggle$previe !== void 0 ? _previewToggle$previe : false;
    _this.state = {
      value: fixControlledValue,
      prePropsValue: fixControlledValue,
      preview: initPreview,
      prePropsPreview: initPreview
    };
    _this.value = fixControlledValue;
    _this.isComposing = false;
    if (type === 'textarea') {
      console.warn('请直接使用 Input.TextArea 代替 type="textarea"');
    }
    return _this;
  }
  (0, _inherits2.default)(Input, _PureComponent);
  return (0, _createClass2.default)(Input, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;
      if (value !== prevProps.value) {
        // 对比更新前props.value，不一致则更新实例中的value值
        this.value = value !== null && value !== void 0 ? value : '';
      }
    }
  }, {
    key: "getInputClassName",
    value: function getInputClassName() {
      var _this$props = this.props,
        size = _this$props.size,
        genre = _this$props.genre,
        status = _this$props.status,
        readOnly = _this$props.readOnly,
        disabled = _this$props.disabled,
        mode = _this$props.mode;
      var preview = this.state.preview;
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('input');
      return (0, _classnames.default)(prefixCls, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-sm"), size === 'small'), "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-").concat(genre), genre !== null && genre !== void 0 ? genre : false), "".concat(prefixCls, "-view"), mode === 'view'), "".concat(prefixCls, "-readonly"), readOnly !== null && readOnly !== void 0 ? readOnly : false), "".concat(prefixCls, "-disabled"), disabled !== null && disabled !== void 0 ? disabled : false), "".concat(prefixCls, "-status-").concat(status), status !== null && status !== void 0 ? status : false), "".concat(prefixCls, "-preview-wrapper"), preview !== null && preview !== void 0 ? preview : false));
    }
  }, {
    key: "handleClear",
    value: function handleClear(e) {
      e.preventDefault();
      var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        onClear = _this$props2.onClear,
        preventFocusAfterClear = _this$props2.preventFocusAfterClear;
      e.stopPropagation();
      if (!('value' in this.props)) {
        this.value = '';
      }
      this.setState({
        value: ''
      });
      if (onChange) {
        // @ts-ignore
        onChange({
          target: {
            value: ''
          }
        });
      }
      if ((0, _utils.isFunction)(onClear)) {
        onClear();
      }
      if (!preventFocusAfterClear) {
        this.focus();
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var dispatchChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var onChange = this.props.onChange;
      var value = e.target.value;
      if (dispatchChange && onChange && value !== this.value) {
        onChange(e);
      }
      if (!('value' in this.props)) {
        this.value = value;
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this$props3 = this.props,
        onPressEnter = _this$props3.onPressEnter,
        onKeyDown = _this$props3.onKeyDown,
        dispatchChange = _this$props3.dispatchChange;
      if (e.keyCode === _utils.KEYCODE.ENTER) {
        this.handleChange(e, (0, _utils.getSaftyArray)(dispatchChange).includes('onPressEnter'));
        // @ts-ignore
        onPressEnter && onPressEnter(e);
      }
      var type = this.props.type;
      if (type === 'number' && e.keyCode === 69) {
        e.preventDefault();
      }
      onKeyDown && onKeyDown(e);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var _this$props4 = this.props,
        onBlur = _this$props4.onBlur,
        dispatchChange = _this$props4.dispatchChange;
      onBlur && onBlur(e);
      this.handleChange(e, (0, _utils.getSaftyArray)(dispatchChange).includes('onBlur'));
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      var _this$props5 = this.props,
        onInput = _this$props5.onInput,
        dispatchChange = _this$props5.dispatchChange;
      if (dispatchChange && !(0, _utils.getSaftyArray)(dispatchChange).includes('onInput')) {
        this.setState({
          value: e.target.value
        });
      } else {
        this.handleChange(e);
      }
      onInput && onInput(e);
    }
  }, {
    key: "handleCompositionStart",
    value: function handleCompositionStart(e) {
      var maxLength = this.props.maxLength;
      if (maxLength !== Infinity) {
        this.isComposing = true;
      }
      var onCompositionStart = this.props.onCompositionStart;
      if (onCompositionStart) {
        onCompositionStart(e);
      }
    }
  }, {
    key: "handleCompositionEnd",
    value: function handleCompositionEnd(e) {
      var maxLength = this.props.maxLength;
      if (this.isComposing && maxLength !== Infinity) {
        this.isComposing = false;
        // @ts-ignore
        this.handleInput(e);
      }
      var onCompositionEnd = this.props.onCompositionEnd;
      if (onCompositionEnd) {
        onCompositionEnd(e);
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      this.inputRef.current.blur();
    }
  }, {
    key: "renderCount",
    value: function renderCount() {
      var _this$props6 = this.props,
        maxLength = _this$props6.maxLength,
        showCount = _this$props6.showCount;
      var value = this.state.value;
      var valueLength = String(value).length || 0;
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('input');
      var content = null;
      if (showCount && maxLength !== Infinity) {
        if (this.props.isTruncation === false && valueLength > maxLength) {
          content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
            className: "".concat(prefixCls, "-count-value-exceed")
          }, valueLength), /*#__PURE__*/_react.default.createElement("span", null, "/", maxLength));
        } else {
          content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Math.min(valueLength, maxLength), "/", maxLength);
        }
      } else if (showCount) {
        content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, valueLength);
      }
      var countClassName = (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-count"), true));
      return content && ( /*#__PURE__*/_react.default.createElement("span", {
        className: countClassName
      }, content));
    }
  }, {
    key: "renderStatusIcon",
    value: function renderStatusIcon(status) {
      if (status === 'validating') {
        return /*#__PURE__*/_react.default.createElement(_icon.default, {
          type: "loading"
        });
      }
      return /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "".concat(status, "-circle")
      });
    }
  }, {
    key: "renderAffix",
    value: function renderAffix(children) {
      var _this$props7 = this.props,
        prefix = _this$props7.prefix,
        suffix = _this$props7.suffix,
        clearable = _this$props7.clearable,
        status = _this$props7.status,
        hasFeedback = _this$props7.hasFeedback,
        disabled = _this$props7.disabled,
        readOnly = _this$props7.readOnly;
      var value = this.state.value;
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('input');
      var affixBaseClassName = "".concat(prefixCls, "-affix");
      var prefixClassName = (0, _classnames.default)(affixBaseClassName, "".concat(prefixCls, "-prefix"));
      var suffixClassName = (0, _classnames.default)(affixBaseClassName, "".concat(prefixCls, "-suffix"));
      var clearIconClassName = (0, _classnames.default)(affixBaseClassName, "".concat(prefixCls, "-clear"));
      var statusIconClassName = (0, _classnames.default)(affixBaseClassName, "".concat(prefixCls, "-status-icon"));
      var prefixNode = null;
      if ((0, _utils.isString)(prefix)) {
        prefixNode = /*#__PURE__*/_react.default.createElement(_icon.default, {
          type: prefix
        });
      } else if ( /*#__PURE__*/(0, _react.isValidElement)(prefix)) {
        prefixNode = prefix;
      }
      var suffixNode = null;
      if ((0, _utils.isString)(suffix)) {
        suffixNode = /*#__PURE__*/_react.default.createElement(_icon.default, {
          type: suffix
        });
      } else if ( /*#__PURE__*/(0, _react.isValidElement)(suffix)) {
        suffixNode = suffix;
      }
      var clearIcon = clearable && value.length && !disabled && !readOnly ? ( /*#__PURE__*/_react.default.createElement("span", {
        className: clearIconClassName
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "error-circle",
        onClick: this.handleClear,
        onMouseDown: this.handleClear
      }))) : null;
      // validate status
      var statusIcon = status === 'validating' || status && hasFeedback ? ( /*#__PURE__*/_react.default.createElement("span", {
        className: statusIconClassName
      }, this.renderStatusIcon(status))) : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("".concat(prefixCls, "-affix-wrapper"))
      }, prefixNode && ( /*#__PURE__*/_react.default.createElement("span", {
        className: prefixClassName
      }, prefixNode)), children, clearIcon, this.renderCount(), suffixNode && ( /*#__PURE__*/_react.default.createElement("span", {
        className: suffixClassName
      }, suffixNode)), statusIcon);
    }
  }, {
    key: "renderAddon",
    value: function renderAddon(children) {
      var _this$props8 = this.props,
        addonBefore = _this$props8.addonBefore,
        addonAfter = _this$props8.addonAfter;
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('input');
      if (!addonBefore && !addonAfter) {
        return children;
      }
      var addonBeforeClassName = (0, _classnames.default)("".concat(prefixCls, "-addon"), "".concat(prefixCls, "-addon-before"));
      var addonAfterClassName = (0, _classnames.default)("".concat(prefixCls, "-addon"), "".concat(prefixCls, "-addon-after"));
      var addonBeforeNode = addonBefore ? /*#__PURE__*/_react.default.createElement("div", {
        className: addonBeforeClassName
      }, addonBefore) : null;
      var addonAfterNode = addonAfter ? /*#__PURE__*/_react.default.createElement("div", {
        className: addonAfterClassName
      }, addonAfter) : null;
      /*
       * const groupClassName = classNames(`${prefixCls}-group`, {
       *   [`${prefixCls}-group-sm`]: size === 'small',
       *   [`${prefixCls}-group-lg`]: size === 'large',
       *   [`${prefixCls}-group-${genre}`]: true,
       * });
       * const groupInputName = `${prefixCls}-group-input`;
       */
      return (
        /*#__PURE__*/
        // <span className={groupClassName}>
        _react.default.createElement(_react.default.Fragment, null, addonBeforeNode, children, addonAfterNode)
        // </span>
      );
    }
  }, {
    key: "renderPreviewIcon",
    value: function renderPreviewIcon() {
      var editIcon = null;
      var previewIconRender = this.props.previewIconRender;
      if ((0, _utils.isFunction)(previewIconRender)) {
        editIcon = previewIconRender(this.state.preview);
      } else {
        editIcon = /*#__PURE__*/_react.default.createElement(_icon.default, {
          type: "edit-o"
        });
      }
      return /*#__PURE__*/_react.default.cloneElement(editIcon, {
        onClick: this.handlePreviewChange
      });
    }
  }, {
    key: "render",
    value: function render() {
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('input');
      var _this$props9 = this.props,
        className = _this$props9.className,
        style = _this$props9.style,
        textAlign = _this$props9.textAlign;
      var _this$state = this.state,
        value = _this$state.value,
        preview = _this$state.preview;
      var otherProps = (0, _utils.dropProps)(this.props, ['dispatchChange', 'defaultValue', 'addonBefore', 'addonAfter', 'clearable', 'onClear', 'style', 'onPressEnter', 'prefix', 'suffix', 'size', 'onChange', 'className', 'showCount', 'isTruncation', 'preventFocusAfterClear', 'textAlign', 'genre', 'hasFeedback', 'status', 'previewIconRender', 'previewToggle']);
      if (!this.props.isTruncation) {
        otherProps = _objectSpread(_objectSpread({}, otherProps), {}, {
          maxLength: undefined
        });
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(this.getInputClassName(), className),
        style: style
      }, preview ? ( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-preview-content")
      }, value), this.renderPreviewIcon())) : this.renderAddon(this.renderAffix( /*#__PURE__*/_react.default.createElement("input", _objectSpread(_objectSpread({}, otherProps), {}, {
        className: "".concat(prefixCls, "-inner-input"),
        style: {
          textAlign: textAlign
        },
        value: value,
        ref: this.inputRef,
        onChange: this.handleInput,
        onCompositionStart: this.handleCompositionStart,
        onCompositionEnd: this.handleCompositionEnd,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};
      if ('value' in nextProps) {
        var _nextProps$value;
        // 如果可控，当props.value变化触发state.value变化并记录本次的props.value
        var fixValue = (_nextProps$value = nextProps.value) !== null && _nextProps$value !== void 0 ? _nextProps$value : '';
        if (fixValue !== prevState.prePropsValue) {
          newState = _objectSpread(_objectSpread({}, newState), {}, {
            value: fixValue,
            prePropsValue: fixValue
          });
        }
        if (nextProps.previewToggle !== prevState.prePropsPreview) {
          var _nextProps$previewTog, _nextProps$previewTog2;
          var newPreview = (0, _utils.isBoolean)(nextProps.previewToggle) ? nextProps.previewToggle : (_nextProps$previewTog = (_nextProps$previewTog2 = nextProps.previewToggle) === null || _nextProps$previewTog2 === void 0 ? void 0 : _nextProps$previewTog2.preview) !== null && _nextProps$previewTog !== void 0 ? _nextProps$previewTog : false;
          newState = _objectSpread(_objectSpread({}, newState), {}, {
            preview: newPreview,
            prePropsPreview: newPreview
          });
        }
      }
      return Object.keys(newState).length > 0 ? newState : null;
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(Input, "TextArea", _TextArea.default);
(0, _defineProperty2.default)(Input, "InputGroup", _InputGroup.default);
(0, _defineProperty2.default)(Input, "Password", _Password.default);
(0, _defineProperty2.default)(Input, "Search", _Search.default);
(0, _defineProperty2.default)(Input, "contextType", _configProvider.ConfigContext);
(0, _defineProperty2.default)(Input, "displayName", 'Input');
(0, _defineProperty2.default)(Input, "defaultProps", {
  type: 'text',
  clearable: true,
  maxLength: Infinity,
  // 文本最大长度
  preventFocusAfterClear: false,
  textAlign: 'left',
  isTruncation: true
});
var _default = exports.default = Input;